export const MEDICINE = {
  en_US: 'Medicine',
  es_ES: 'Medicamento',
  pt_BR: 'Medicamento',
};

export const MEDICINE_COUNTRY_OF_ORIGIN = {
  en_US: 'Country of origin',
  es_ES: 'País de origen',
  pt_BR: 'País de origem',
};

export const EQUIVALENT_BRANDS = {
  en_US: 'Equivalent brands',
  es_ES: 'Marcas equivalentes',
  pt_BR: 'Marcas equivalentes',
};

export const MEDICINE_INFORMATION = {
  en_US: 'Information',
  es_ES: 'Información',
  pt_BR: 'Informações',
};

export const MEDICINE_COUNTRY_OF_TRAVEL = {
  en_US: 'Destination country',
  pt_BR: 'País de destino',
  es_ES: 'País de destino',
};

export const FIND_BASED_ON_SUBSTANCE = {
  en_US: 'Find equivalent brands based on active substance',
  es_ES: 'Encuentre marcas equivalentes según la sustancia activa',
  pt_BR: 'Encontre marcas equivalentes com base na substância ativa',
};

export const PRODUCTS = {
  en_US: 'Products',
  es_ES: 'Productos',
  pt_BR: 'Produtos',
};

export const SEARCH_MEDICINES_BY_NAME_AND_COUNTRY = {
  en_US: 'Search medicines by name and country',
  es_ES: 'Buscar medicamentos por nombre y país',
  pt_BR: 'Pesquise medicamentos por nome e país',
};

export const MEDICINE_NOT_FOUND = {
  en_US:
    'No medicine was found for this name and country, please review and try again.',
  es_ES:
    'No se encontró ningún medicamento para este nombre y país, revíselo e inténtelo nuevamente.',
  pt_BR:
    'Nenhum medicamento foi encontrado para este nome e país. Revise e tente novamente.',
};

export const EQUIVALENT_MEDICINE_NOT_FOUND = {
  en_US: 'No medicine was found in this country.',
  es_ES: 'No se encontró ningún medicamento en este país.',
  pt_BR: 'Nenhum medicamento foi encontrado neste país.',
};

export const FIND_DETAILED_INFORMATION = {
  en_US: 'Find documents with detailed information about this medicine.',
  es_ES:
    'Encuentre documentos con información detallada sobre este medicamento.',
  pt_BR:
    'Encontre documentos com informações detalhadas sobre este medicamento.',
};

export const MEDICINE_INFORMATION_NOT_FOUND = {
  en_US: 'No documents were found for this medicine.',
  es_ES: 'No se encontraron documentos para este medicamento.',
  pt_BR: 'Não foram encontrados documentos para este medicamento',
};

export const DOCUMENTS = {
  en_US: 'Documents',
  es_ES: 'Documentos',
  pt_BR: 'Documentos',
};

export const ADMINISTRATION_ROUTE = {
  en_US: 'Administration route',
  es_ES: 'Vía de administración',
  pt_BR: 'Via de administração',
};

export const PHARMACEUTICAL_FORM = {
  en_US: 'Pharmaceutical form',
  es_ES: 'Forma farmaceutica',
  pt_BR: 'Forma farmacêutica',
};

export const VIEW_DOCUMENT = {
  en_US: 'VIEW DOCUMENT',
  es_ES: 'VER DOCUMENTO',
  pt_BR: 'VER DOCUMENTO',
};

export const FILTER_MEDICINES = {
  en_US: 'Filter medicines',
  es_ES: 'Filtrar medicamentos',
  pt_BR: 'Filtrar medicamentos',
};

export const FILTER_DOCUMENTS = {
  en_US: 'Filter documents',
  es_ES: 'Filtrar documentos',
  pt_BR: 'Filtrar documentos',
};
